<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Procedures' : 'Deleted Procedures'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/procedures/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search procedures..."
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="status"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="intensity"
                    v-model="filter.intensity_filter"
                    :items="intensityFilters"
                    label="Intensity"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-speedometer"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="procedures.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" :style="`height: ${tableHeight}px`">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="tableHeight"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start">Sr No</th>
                      <th class="text-start">Status</th>
                      <th class="text-start">Name</th>
                      <th class="text-start">Description</th>
                      <th class="text-start">Default Speed</th>
                      <th class="text-start">Max Speed</th>
                      <th class="text-start">Max Heart Rate</th>
                      <th class="text-start">Unweighting</th>
                      <th class="text-start">Intensity</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="procedures.length != 0">
                    <tr v-for="(procedure, i) in procedures" :key="`procedure${i}`">
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="procedure.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Procedure is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="procedure.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Procedure is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ procedure.name || "Unnamed Procedure" }}</td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              {{ truncateText(procedure.description, 30) || "No description" }}
                            </span>
                          </template>
                          <span>{{ procedure.description || "No description" }}</span>
                        </v-tooltip>
                      </td>
                      <td>{{ formatSpeed(procedure.default_speed) }}</td>
                      <td>{{ formatSpeed(procedure.max_speed) }}</td>
                      <td>{{ formatHeartRate(procedure.max_heart_rate) }}</td>
                      <td>{{ formatUnweighting(procedure.default_unweighting) }}</td>
                      <td>
                        <v-chip
                          small
                          :color="getIntensityColor(procedure)"
                          text-color="white"
                        >
                          {{ getIntensityLevel(procedure) }}
                        </v-chip>
                      </td>

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(procedure.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this procedure</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/procedures/${encryptIt(procedure.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this procedure</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="success"
                                @click="Restore_this(procedure.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this procedure</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="10" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_procedure" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Procedure deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_procedure = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_procedure" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Procedure restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_procedure = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";
export default {
  name: "proceduresPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        intensity_filter: "",
        show_deleted: false,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_procedure: false,
      is_restored_procedure: false,
      procedures: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      intensityFilters: [
        {
          id: 0,
          text: "Select Intensity",
          value: "",
        },
        { id: "rehabilitation", text: "Rehabilitation Suitable", value: "rehabilitation_suitable" },
        { id: "athletic", text: "Athletic Suitable", value: "athletic_suitable" },
      ],
      isLoading: false,
      isExcelloading: false,
    };
  },
  computed: {
    tableHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 250; // Mobile phones
        case 'sm': return 300; // Tablets
        case 'md': return 400; // Small laptops
        case 'lg': return 500; // Desktop
        case 'xl': return 600; // Large desktop
        default: return 400;
      }
    }
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.intensity_filter = this.filter.intensity_filter
        ? this.filter.intensity_filter
        : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;

      // Add intensity filter
      if (this.filter.intensity_filter) {
        query += "&" + this.filter.intensity_filter + "=1";
      }

      await axios
        .get(`procedures?${query}`)
        .then((response) => {
          this.procedures = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // Only redirect to login if it's actually an authentication error
          if (error.response && error.response.status === 401) {
            //window.location.href = "/auth/login";
          }
        });
      this.isLoading = false;
    },
    async Delete_this(id) {
      this.delete_procedure = true;
      await axios
        .post(`/procedures/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_procedure = false;
          this.is_deleted_procedure = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response && error.response.status === 401) {
            //window.location.href = "/auth/login";
          }
        });
    },
    async generateExcel() {
      this.isExcelloading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.intensity_filter = this.filter.intensity_filter
        ? this.filter.intensity_filter
        : "";

      let query =
        "is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;

      // Add intensity filter
      if (this.filter.intensity_filter) {
        query += "&" + this.filter.intensity_filter + "=1";
      }

      try {
        const response = await axios.get(`/procedures/excel?${query}`, {
          responseType: 'blob'
        });
        
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        // Try to get filename from response headers
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'procedures.xlsx';
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }
        
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error generating Excel:', error);
      }

      this.isExcelloading = false;
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    async Restore_this(id) {
      this.restore_procedure = true;
      await axios
        .post(`/procedures/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_procedure = false;
          this.is_restored_procedure = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response && error.response.status === 401) {
            //window.location.href = "/auth/login";
          }
        });
    },
    formatSpeed(speed) {
      return speed ? speed + " mph" : "Not set";
    },
    formatHeartRate(heartRate) {
      return heartRate ? heartRate + " bpm" : "Not set";
    },
    formatUnweighting(unweighting) {
      return unweighting ? unweighting + "%" : "Not set";
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    getIntensityLevel(procedure) {
      const speed = parseFloat(procedure.default_speed) || 0;
      const heartRate = parseInt(procedure.max_heart_rate) || 0;

      if (speed <= 2.0 && heartRate <= 120) {
        return 'Low';
      } else if (speed <= 5.0 && heartRate <= 150) {
        return 'Moderate';
      } else if (speed <= 8.0 && heartRate <= 170) {
        return 'High';
      } else {
        return 'Very High';
      }
    },
    getIntensityColor(procedure) {
      const level = this.getIntensityLevel(procedure);
      switch (level) {
        case 'Low':
          return 'green';
        case 'Moderate':
          return 'orange';
        case 'High':
          return 'red';
        case 'Very High':
          return 'purple';
        default:
          return 'grey';
      }
    },
  },
};
</script>